import { isVueComponent, getFirstDescendantComponentByName } from '../../core/utils'
import _ from 'lodash'
import $ from 'jquery'
import { document } from 'ssr-window'
import Dragging from '../../core/mixins/dragging/KDragging'

const EVENT_NAME_SPACING = 'kamala.layout.resize.bar'
const gap = 4
const reverseGap = 0

const limitValidate = function (value) {
  if (_.isNumber(value)) {
    return true
  }
  if (/^\d+%$/.test(value)) {
    return true
  }
}

export default {
  inject: ['context'],
  mixins: [Dragging],
  props: {
    resizable: {
      type: Boolean,
      default: false,
    },
    max: {
      validator: (value) => limitValidate(value),
      default: null,
    },
    min: {
      validator: (value) => limitValidate(value),
      default: null,
    },
  },
  data() {
    return {
      resizeBarPlacement: '',
      dragging: false,
      delta: 0,
      toLimit: false,
    }
  },
  computed: {
    name() {
      return this.$options.name
    },
    isVertical() {
      return this.resizeBarPlacement === 'top' || this.resizeBarPlacement === 'bottom'
    },
    resizeProperty() {
      return this.isVertical ? 'height' : 'width'
    },
    resizeDataForContainer() {
      const style = {}

      if (this.dragging) {
        style.overflow = 'visible'
      }
      // if (this.vertical) {
      //   style.maxHeight = this.max
      //   style.minHeight = this.min
      // } else {
      //   style.maxWidth = this.max
      //   style.minWidth = this.min
      // }

      return {
        style,
      }
    },
    hasLayoutComponentDragging() {
      return this.context.hasLayoutComponentDragging
    },
  },
  mounted() {
    if (this.resizable && this.$options.name === 'KAside') {
      this.$nextTick(() => {
        const index = _.findIndex(this.$parent.$children, this)
        if (index !== 0) {
          this.resizeBarPlacement = 'left'
        }
      })
    }
  },
  methods: {
    resize() {
      const selfResizeStyle = {}
      const siblingResizeStyle = {}

      const { delta, resizeProperty } = this
      const currentSelfResizeValue = this.$el.getBoundingClientRect()[resizeProperty]
      const currentSiblingResizeValue = this.sibling.$el.getBoundingClientRect()[resizeProperty]

      switch (this.resizeBarPlacement) {
        case 'bottom':
        case 'right':
          selfResizeStyle[resizeProperty] = currentSelfResizeValue + delta + 'px'
          siblingResizeStyle[resizeProperty] = currentSiblingResizeValue - delta + 'px'
          break
        case 'top':
        case 'left':
          selfResizeStyle[resizeProperty] = currentSelfResizeValue - delta + 'px'
          siblingResizeStyle[resizeProperty] = currentSiblingResizeValue + delta + 'px'
          break
      }

      this.setResizeStyle(selfResizeStyle)
      this.sibling.setResizeStyle && this.sibling.setResizeStyle(siblingResizeStyle)
    },
    getSibling() {
      let sibling = null
      const index = _.findIndex(this.$parent.$children, this)
      switch (this.resizeBarPlacement) {
        case 'bottom':
        case 'right':
          sibling = this.$parent.$children[index + 1]
          break
        case 'top':
        case 'left':
          sibling = this.$parent.$children[index - 1]
          break
      }

      if (sibling && isVueComponent(sibling) && !sibling.setResizeStyle) {
        sibling = getFirstDescendantComponentByName(sibling, 'KMain')
        console.log('sibling: ', sibling)
      }

      return sibling
    },
    getLimitNumberValue(value) {
      if (_.isNumber(value)) {
        return value
      }

      const resizeProperty = this.resizeProperty
      const result = /^(\d+)%$/.exec(value)
      if (result && result.length) {
        return +result[1] * this.$parent.$el.getBoundingClientRect()[resizeProperty] / 100
      }
    },
    getMaxDelta(el, reverse = false) {
      const resizeProperty = this.resizeProperty
      const rect = el.getBoundingClientRect()
      let maxDelta = 0
      let myGap = reverse ? reverseGap : gap
      const limitValue = this.getLimitNumberValue(reverse ? this.max : this.min)

      if (reverse && limitValue) {
        myGap = _.max([myGap, rect[resizeProperty] + this.$el.getBoundingClientRect()[resizeProperty] - (limitValue || 0)])
      } else if (limitValue) {
        myGap = _.max([myGap, limitValue])
      }

      maxDelta = _.max([rect[resizeProperty] - myGap, 0])

      return maxDelta
    },
    calcPosition(e) {
      const currentX = e.clientX
      const currentY = e.clientY

      let delta = 0
      const currentDelta = this.isVertical ? currentY - this.startY : currentX - this.startX
      let toLimit = false
      const { maxDelta, maxReverseDelta } = this

      switch (this.resizeBarPlacement) {
        case 'bottom':
        case 'right':
          if (currentDelta < 0) {
            delta = Math.max(currentDelta, -maxDelta)
            toLimit = delta === -maxDelta
          } else {
            delta = Math.min(currentDelta, maxReverseDelta)
            toLimit = delta === maxReverseDelta
          }
          break
        case 'top':
        case 'left':
          if (currentDelta < 0) {
            delta = Math.max(currentDelta, -maxReverseDelta)
            toLimit = delta === -maxReverseDelta
          } else {
            delta = Math.min(currentDelta, maxDelta)
            toLimit = delta === maxDelta
          }
          break
      }

      this.delta = delta
      this.toLimit = toLimit
    },
    handleDragStart(e) {
      this.delta = 0
      this.toLimit = false

      this.startX = e.clientX
      this.startY = e.clientY
      this.sibling = this.getSibling()
      this.maxDelta = this.getMaxDelta(this.$el)
      this.maxReverseDelta = this.getMaxDelta(this.sibling.$el, true)

      $(document)
        .one(`mouseup.${EVENT_NAME_SPACING}`, this.handleDragEnd)
        .on(`mousemove.${EVENT_NAME_SPACING}`, this.handleDragMove)
        .on(`selectstart.${EVENT_NAME_SPACING}`, () => {
          return false
        })
    },
    handleDragMove(e) {
      e.preventDefault()
      this.dragging = true
      this.setGlobalDragging(true)
      this.context.hasLayoutComponentDragging = true
      this.calcPosition(e)
    },
    handleDragEnd(e) {
      this.dragging = false
      this.setGlobalDragging(false)
      this.context.hasLayoutComponentDragging = false
      this.calcPosition(e)

      $(document)
        .off(`mousemove.${EVENT_NAME_SPACING}`)
        .off(`selectstart.${EVENT_NAME_SPACING}`)

      this.resize()
    },
    renderThumb() {
      const css = {
        'km-resize-bar__thumb': true,
      }

      const events = {
        mousedown: this.handleDragStart,
      }

      const data = {
        class: css,
        on: events,
      }
      return (
        <div
          {...data}
        >
        </div>
      )
    },
    renderGhost() {
      if (!this.dragging) {
        return
      }

      const css = {
        'km-resize-bar__ghost': true,
        'km-resize-bar__ghost--vertical': this.isVertical,
        'km-resize-bar__ghost--limit': this.toLimit,
        [`km-resize-bar__ghost--${this.resizeBarPlacement}`]: true,
      }

      const style = {}

      if (!this.isVertical) {
        _.assign(style, {
          width: Math.abs(this.delta) + 'px',
          transform: this.delta > 0 ? '' : `translateX(${this.delta}px)`,
        })
      } else {
        _.assign(style, {
          height: Math.abs(this.delta) + 'px',
          transform: this.delta > 0 ? '' : `translateY(${this.delta}px)`,
        })
      }

      const data = {
        class: css,
        style,
      }

      return (
        <div
          {...data}
        >
        </div>
      )
    },
    renderResizeBar() {
      if (!this.resizable) {
        return
      }

      if (this.hasGlobalDragging && !this.dragging) {
        return
      }

      const css = {
        'km-resize-bar': true,
        [`km-resize-bar--${this.resizeBarPlacement}`]: true,
      }

      const style = {}
      if (this.dragging) {
        _.assign(style, {
          zIndex: 9999,
        })
      }

      const data = {
        class: css,
        style,
      }

      return (
        <div
          {...data}
        >
          {this.renderThumb()}
          {this.renderGhost()}
        </div>
      )
    },
  },
}
